export default "__VITE_ASSET__khfmbWc$__"